export default {
	label: 'Time line',
	name: 'time-line',
	widget: 'object',
	required: false,
	fields: [
		{
			label: 'Items',
			name: 'items',
			widget: 'list',
			required: false,
			fields: [
				{
					label: 'Title',
					name: 'title',
					required: false,
					widget: 'string'
				},
				{
					label: 'Description',
					name: 'description',
					required: false,
					widget: 'text'
				}
			]
		}
	]
};
